export const RESUME_URL =
	'https://drive.google.com/file/d/1M4PNYrAi1U5XrBmbfFSP-DXe4pLXNSMs/view?usp=sharing';

export const RESUME_TEXT = {
	text: 'View or download my full resume ',
	here: 'here.',
};

export const SKILL_TYPES = {
	front: { id: 'front_end', label: 'Front-End Skills' },
	back: { id: 'back_end', label: 'Back-End Skills' },
	other: { id: 'other', label: 'Other Skills' },
};

export const SKILLS = [
	{
		name: 'JavaScript',
		file: 'javascript.svg',
		type: SKILL_TYPES.front.id,
	},
	{
		name: 'React',
		file: 'react.svg',
		type: SKILL_TYPES.front.id,
	},
	{
		name: 'Redux',
		file: 'redux.svg',
		type: SKILL_TYPES.front.id,
	},
	{
		name: 'HTML',
		file: 'html-5.svg',
		type: SKILL_TYPES.front.id,
	},
	{
		name: 'CSS',
		file: 'css.svg',
		type: SKILL_TYPES.front.id,
	},
	{
		name: 'Sass',
		file: 'sass.svg',
		type: SKILL_TYPES.front.id,
	},
	{
		name: 'Node.js',
		file: 'nodejs.svg',
		type: SKILL_TYPES.back.id,
	},
	{
		name: 'Express.js',
		file: 'expressjs.svg',
		type: SKILL_TYPES.back.id,
	},
	{
		name: 'Bootstrap',
		file: 'bootstrap.svg',
		type: SKILL_TYPES.front.id,
	},
	{
		name: 'Materialize',
		file: 'materializecss.svg',
		type: SKILL_TYPES.front.id,
	},
	{
		name: 'Bulma',
		file: 'bulma.svg',
		type: SKILL_TYPES.front.id,
	},
	{
		name: 'Jest',
		file: 'jest.svg',
		type: SKILL_TYPES.other.id,
	},
	{
		name: 'MongoDB',
		file: 'mongodb.svg',
		type: SKILL_TYPES.back.id,
	},
	{
		name: 'Mongoose',
		file: 'mongoose.png',
		type: SKILL_TYPES.back.id,
	},
	{
		name: 'GraphQL | Apollo Client',
		file: 'graphql.svg',
		type: SKILL_TYPES.front.id,
	},
	{
		name: 'GraphQL | Apollo Server',
		file: 'apollo.svg',
		type: SKILL_TYPES.back.id,
	},
	{
		name: 'MySQL',
		file: 'mysql.svg',
		type: SKILL_TYPES.back.id,
	},
	{
		name: 'Sequelize',
		file: 'sequelize.svg',
		type: SKILL_TYPES.back.id,
	},
	{
		name: 'Git',
		file: 'git-icon.svg',
		type: SKILL_TYPES.other.id,
	},
	// {
	// 	name: 'Webpack',
	// 	file: 'webpack.svg',
	// 	type: SKILL_TYPES.front.id,
	// },
	{
		name: 'Heroku',
		file: 'heroku.svg',
		type: SKILL_TYPES.other.id,
	},
];
